import { render, staticRenderFns } from "./entry-description.vue?vue&type=template&id=3a252b62&"
import script from "./entry-description.vue?vue&type=script&lang=js&"
export * from "./entry-description.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports